import { createSlice } from '@reduxjs/toolkit';

const signUpContentSlice = createSlice({
    name: 'signUpContent',
    initialState: {
        signUpContent: null, 
    },
    reducers: {
        setSignUpContent: (state, action) => {
            state.signUpContent = action.payload;
        },
    },
});


export const { setSignUpContent } = signUpContentSlice.actions;
export default signUpContentSlice.reducer;
